<pre><code [highlight]="code"></code></pre>
